export default __webpack_public_path__ + "static/media/Exyn Technologies.d143b5ac.png";